var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('AppInfoEmailBrySendDeliveryDetails',{attrs:{"detalhesEnvioEntrega":_vm.detalhesEnvioEntrega}}),_vm._v(" "),_c('AppInfoEmailBryReadingDetails',{attrs:{"detalhesLeitura":_vm.detalhesLeitura}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-62d866d5","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/provider-bry/InfoEmailBry.vue
// module id = null
// module chunks = 